import { DateField } from '@components/Fields/DateField';
import { Fieldset } from '@components/Fields/Fieldset';
import { FloatField } from '@components/Fields/FloatField';
import { GridItem } from '@components/GridItem';
import { HorizontalGrid } from '@components/HorizontalGrid';
import { StringField } from '@components/Fields/StringField';
import { VerticalGrid } from '@components/VerticalGrid';
import { IForm } from '@hooks/useForm';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import ImportContactsIcon from '@material-ui/icons/ImportContacts';
import MemoryIcon from '@material-ui/icons/Memory'
import { IComboTipoCobrancaChip, IContratoCliente } from '@model/ContratoCliente';
import React from 'react';
import { IComboVendedor } from '@model/Vendedor';
import { ComboField } from '@components/Fields/ComboField';
import { useComboBoolean } from '@hooks/useComboBoolean';
import { MenuItem } from '@material-ui/core';

export type ContratoFormularioProps = {
    form: IForm<Partial<IContratoCliente>>
    vendedorCombo: IComboVendedor
    tipoCobrancaChipCombo: IComboTipoCobrancaChip
}

export function ContratoFormulario ({form, vendedorCombo, tipoCobrancaChipCombo}: ContratoFormularioProps) {
    
    const { fields } = form;
    const cobrarInteiraCombo = useComboBoolean("0");


    return (
        <VerticalGrid>
            <Fieldset
                icon={<AssignmentIndIcon />}
                title="Parâmetros"
            >
                <HorizontalGrid spacing={2}>
                    <GridItem xs={3}>
                        <DateField
                            field={fields.inicio}
                            label="Início"
                            required
                            //disableFuture
                        />
                    </GridItem>

                    <GridItem xs={3}>
                        <FloatField
                            field={fields.valorPlano}
                            label="Valor Plano"
                            required
                        />
                    </GridItem>

                    <GridItem xs={3}>
                        <FloatField
                            field={fields.valorAssessoria}
                            label="Valor Consultoria"
                            required
                        />
                    </GridItem>

                    <GridItem xs={3}>
                        <FloatField
                            field={fields.franquiaGb}
                            label="Franguia GB"
                            required
                        />
                    </GridItem>

                    <GridItem xs={4}>
                        <ComboField
                            field={fields.vendedorId}
                            label="Vendedor"
                            disabled
                        >
                            <MenuItem key="0" value="">Nenhum</MenuItem>
                            {
                                vendedorCombo.createOptions()
                            }
                        </ComboField>
                    </GridItem>

                    <GridItem xs={3}>
                        <ComboField 
                            field={form.fields.cobrarInteira}
                            label="Cobrar Inteira"
                            helperText="Desconsiderar proporcional na primeira fatura"
                            required
                        >
                            {cobrarInteiraCombo.createOptions()}
                        </ComboField>
                    </GridItem>

                </HorizontalGrid>
            </Fieldset>

            <Fieldset
                icon={<MemoryIcon />}
                title="Chip"
            >
                <HorizontalGrid spacing={2}>
                    <GridItem xs={3}>
                        <FloatField
                            field={fields.valorChip}
                            label="Valor Chip"
                            required
                        />
                    </GridItem>

                    <GridItem xs={3}>
                        <ComboField 
                            field={form.fields.tipoCobrancaChip}
                            label="Tipo Cobrança Chip"
                            helperText="Como o Chip será cobrado?"
                            required={fields.valorChip.value > 0}
                            disabled={fields.valorChip.value <= 0}
                        >
                            {tipoCobrancaChipCombo.createOptions()}
                        </ComboField>
                    </GridItem>
                </HorizontalGrid>
            </Fieldset>

            <Fieldset
                icon={<ImportContactsIcon />}
                title="Outras Informações"
            >
                <HorizontalGrid spacing={2}>
                    <GridItem xs={12}>
                        <StringField 
                            field={fields.usuarioLinha}
                            label="Usuário da Linha"
                        />
                    </GridItem>
                </HorizontalGrid>
            </Fieldset>
       </VerticalGrid>
    )
}